/* unplugin-vue-components disabled */import script from "./anchor-box.vue?vue&type=script&lang=jsx"
export * from "./anchor-box.vue?vue&type=script&lang=jsx"

import "./anchor-box.vue?vue&type=style&index=0&id=24c4fec6&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24c4fec6"]])

export default __exports__